import { format, isBefore, isSameYear } from "date-fns";
import { DateFormat } from "types";
import { enUS, nb } from "date-fns/locale";

const formats = {
  dayDateMonth: "EEE d. LLL", // Mon 1. jan
  dayDateMonthYear: "EEE d. LLL yyyy", // Mon 1. jan 2019
};
export const getFormat = (d: Date, baseDate = new Date()) => {
  if (isBefore(d, baseDate)) {
    return formats.dayDateMonthYear;
  } else if (isSameYear(d, baseDate)) {
    return formats.dayDateMonth;
  }
  return formats.dayDateMonthYear;
};

export const formatTime = (d: Date): string => {
  return `${d.getHours().toString().padStart(2, "0")}:${d
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;
};

const formatDate = (
  start: Date,
  end: Date,
  locale = "no",
  dateFormat: DateFormat | null = null,
  baseDate = new Date(),
) => {
  let startString, endString;
  if (dateFormat) {
    switch (dateFormat.dateType) {
      case "start_date_and_time":
      case "start_date":
        startString = format(start, getFormat(start, baseDate), {
          locale: locale === "nb" ? nb : enUS,
        });
        return startString.charAt(0).toUpperCase() + startString.slice(1);
      case "start_end_date_and_time":
      case "start_end_date":
        startString = format(start, getFormat(start, baseDate), {
          locale: locale === "nb" ? nb : enUS,
        });
        endString = format(end, getFormat(end, baseDate), { locale: locale === "nb" ? nb : enUS });
        return `${startString.charAt(0).toUpperCase() + startString.slice(1)} - ${
          endString.charAt(0).toUpperCase() + endString.slice(1)
        }`;
      case "dont_show":
        return null;
      case "free_text":
        return dateFormat.dateText;
    }
  }
  startString = format(start, getFormat(start, baseDate), { locale: locale === "nb" ? nb : enUS });
  return startString.charAt(0).toUpperCase() + startString.slice(1);
};

export default formatDate;
